import { createFileRoute } from '@tanstack/react-router';
import { UsersPage, UserManagementStoreProvider } from '@/pages/users';
import { privilegeGuardRoute } from '@/features/authenticate';
import { GROUPED_PRIVILEGES } from '@/entities/authentication';

export const Route = createFileRoute('/_private/manage/users')({
  beforeLoad: () =>
    privilegeGuardRoute({ privileges: GROUPED_PRIVILEGES.userList }),
  component: () => (
    <UserManagementStoreProvider>
      <UsersPage />
    </UserManagementStoreProvider>
  ),
});
